
import React from "react";

const LoadingScreen: React.FC = () => {
  return (
    <div className="flex-grow flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-cecure-700 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading event information...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
